module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "components-container"
  }, [_c('div', {
    staticClass: "fromclass"
  }, [_c('div', {
    staticStyle: {
      "border-bottom": "2px solid #c8c8c8",
      "text-align": "center",
      "height": "50px"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#58666e",
      "font-size": "28px",
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.exportkcbz
    }
  }, [_vm._v("导出")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "scrollArea",
    style: (_vm.innerDialog)
  }, [_c('el-scrollbar', {
    ref: "elScrollbar",
    staticStyle: {
      "height": "100%"
    }
  }, [_c('el-form', {
    staticClass: "small-space",
    staticStyle: {
      "width": "100%",
      "margin-left": "0px"
    },
    attrs: {
      "inline": true,
      "model": _vm.formData,
      "label-position": "right",
      "label-width": "190px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "编号："
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "610px",
      "margin-left": "20px"
    },
    attrs: {
      "disabled": true,
      "name": "BH",
      "autoComplete": "on",
      "maxlength": "30"
    },
    model: {
      value: (_vm.BH),
      callback: function($$v) {
        _vm.BH = $$v
      },
      expression: "BH"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "状态："
    }
  }, [(_vm.courseStandardState == '0') ? _c('div', {
    staticClass: "status",
    staticStyle: {
      "background-color": "#808080"
    }
  }, [_vm._v("\n                            未保存\n                        ")]) : (_vm.courseStandardState == '1') ? _c('div', {
    staticClass: "status",
    staticStyle: {
      "background-color": "#e6a23c"
    }
  }, [_vm._v("\n                            未提交\n                        ")]) : (_vm.courseStandardState == '2') ? _c('div', {
    staticClass: "status",
    staticStyle: {
      "background-color": "#409eff"
    }
  }, [_vm._v("\n                            待审核\n                        ")]) : (_vm.courseStandardState == '3') ? _c('div', {
    staticClass: "status",
    staticStyle: {
      "background-color": "#67c23a"
    }
  }, [_vm._v("\n                            审核通过\n                        ")]) : (_vm.courseStandardState == '4') ? _c('div', {
    staticClass: "status",
    staticStyle: {
      "background-color": "#f56c6c"
    }
  }, [_vm._v("\n                            审核驳回\n                        ")]) : _c('div')]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "起效学年："
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "610px",
      "margin-left": "20px"
    },
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.dqxnxq),
      callback: function($$v) {
        _vm.dqxnxq = $$v
      },
      expression: "dqxnxq"
    }
  }, _vm._l((_vm.xnxq), function(item, index) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "label": item.comboName,
        "value": item.comboValue
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "适用专业"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "610px",
      "margin-left": "20px"
    },
    attrs: {
      "clearable": "",
      "placeholder": "请选择",
      "filterable": ""
    },
    model: {
      value: (_vm.SYZY),
      callback: function($$v) {
        _vm.SYZY = $$v
      },
      expression: "SYZY"
    }
  }, _vm._l((_vm.zy), function(item, index) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "label": item.comboName,
        "value": item.comboValue
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "编制人"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "610px",
      "margin-left": "20px"
    },
    attrs: {
      "disabled": true,
      "name": "BZR",
      "autoComplete": "on",
      "maxlength": "30"
    },
    model: {
      value: (_vm.BZR),
      callback: function($$v) {
        _vm.BZR = $$v
      },
      expression: "BZR"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "编制日期"
    }
  }, [_c('div', {
    staticClass: "block"
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "610px",
      "margin-left": "20px"
    },
    attrs: {
      "name": "BZRQ",
      "align": "right",
      "value-format": "yyyy-MM-dd HH:mm:ss",
      "format": "yyyy-MM-dd HH:mm",
      "type": "datetime",
      "placeholder": "日期"
    },
    model: {
      value: (_vm.BZRQ),
      callback: function($$v) {
        _vm.BZRQ = $$v
      },
      expression: "BZRQ"
    }
  })], 1)]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "课程"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "1340px",
      "margin-left": "20px"
    },
    attrs: {
      "name": "KC",
      "maxlength": "30"
    },
    model: {
      value: (_vm.KC),
      callback: function($$v) {
        _vm.KC = $$v
      },
      expression: "KC"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "fromtitle new1"
  }, [_vm._v("课程性质")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "id": "KCXZ",
      "type": "textarea",
      "name": "KCXZ",
      "rows": "3"
    },
    model: {
      value: (_vm.KCXZ),
      callback: function($$v) {
        _vm.KCXZ = $$v
      },
      expression: "KCXZ"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "fromtitle new1"
  }, [_vm._v("设计思路")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "id": "SJSL",
      "type": "textarea",
      "name": "SJSL",
      "rows": "3"
    },
    model: {
      value: (_vm.SJSL),
      callback: function($$v) {
        _vm.SJSL = $$v
      },
      expression: "SJSL"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "fromtitle new1"
  }, [_vm._v("课程目标")]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "margin-bottom": "20px"
    },
    attrs: {
      "id": "KCMB",
      "type": "textarea",
      "name": "KCMB",
      "rows": "3"
    },
    model: {
      value: (_vm.KCMB),
      callback: function($$v) {
        _vm.KCMB = $$v
      },
      expression: "KCMB"
    }
  }), _vm._v(" "), _c('el-table', {
    ref: "multipleTable",
    staticStyle: {
      "width": "100%",
      "max-height": "600px"
    },
    attrs: {
      "data": _vm.tableData,
      "span-method": _vm.objectSpanMethod,
      "stripe": "",
      "border": "",
      "fit": "",
      "highlight-current-row": "",
      "height": "600px",
      "header-cell-style": {
        'font-weight': '900',
        'color': '#58666e'
      }
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": '工作任务 \n 一级知识点技能点',
      "prop": "job",
      "align": "center",
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": '参考学时',
      "prop": "time",
      "align": "center",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": '技能与学习水平 \n 二级技能点',
      "prop": "skill",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": '技能与学习水平 \n 三级技能点',
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('el-table', {
          attrs: {
            "data": props.row.slevellist,
            "show-header": false,
            "align": "center",
            "stripe": ""
          }
        }, [_c('el-table-column', {
          attrs: {
            "align": "center",
            "prop": "kk_mc"
          }
        })], 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": '知识与学习水平 \n 二级知识点',
      "prop": "knowlage",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": '知识与学习水平 \n 三级知识点',
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('el-table', {
          attrs: {
            "data": props.row.klevellist,
            "show-header": false,
            "align": "center",
            "stripe": ""
          }
        }, [_c('el-table-column', {
          attrs: {
            "align": "center",
            "prop": "kk_mc"
          }
        })], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "height": "90px",
      "margin-top": "25px"
    },
    attrs: {
      "label": "总课时"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "1000px"
    },
    attrs: {
      "disabled": true,
      "name": "ZKS",
      "autoComplete": "on",
      "maxlength": "10"
    },
    model: {
      value: (_vm.ZKS),
      callback: function($$v) {
        _vm.ZKS = $$v
      },
      expression: "ZKS"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "fromtitle new1"
  }, [_vm._v("教学活动参考")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "id": "JXHDCK",
      "type": "textarea",
      "name": "JXHDCK",
      "rows": "3"
    },
    model: {
      value: (_vm.JXHDCK),
      callback: function($$v) {
        _vm.JXHDCK = $$v
      },
      expression: "JXHDCK"
    }
  }), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "课程总学时"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "1000px"
    },
    attrs: {
      "name": "KCZXS",
      "autoComplete": "on",
      "maxlength": "30"
    },
    model: {
      value: (_vm.KCZXS),
      callback: function($$v) {
        _vm.KCZXS = $$v
      },
      expression: "KCZXS"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "zxstsy"
  }, [_vm._v(_vm._s(_vm.zxsts))])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "30px"
    }
  }, [_c('div', {
    staticClass: "fromtitle new1"
  }, [_vm._v("课程标准原件")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('span', {
    staticClass: "fileName"
  }, [_vm._v(_vm._s(_vm.filename))]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin": "10px 0 0 10px"
    },
    attrs: {
      "size": "small",
      "type": "primary"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.download.apply(null, arguments)
      }
    }
  }, [_vm._v("下载")])], 1)], 1)], 1)], 1)], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6afd2dae"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/teachingManage/courseStandard/criterion_for_curriculumShow.vue
// module id = 1853
// module chunks = 502